module.exports = __webpack_public_path__ + "static/media/javascript-js-seeklogo.com.87711407.svg";